import { render, staticRenderFns } from "./ThreeViewer.vue?vue&type=template&id=428adbee&scoped=true"
import script from "./ThreeViewer.vue?vue&type=script&lang=js"
export * from "./ThreeViewer.vue?vue&type=script&lang=js"
import style0 from "./ThreeViewer.vue?vue&type=style&index=0&id=428adbee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428adbee",
  null
  
)

export default component.exports